import type { TFunction } from 'i18next'

import type { IReportEvent } from '@/hooks/useReportStream'

export function formatEventMessage(event: IReportEvent, t: TFunction): string {
  const normalizedType = event.type.replace(/:/g, '_')
  const key = `dashboard.newSearch.generatingReport.feed.events.${normalizedType}`
  const fallback = event.type.replace(/^[^:]+:/, '').replace(/_/g, ' ')
  const data = event.data ?? {}
  const normalized: Record<string, unknown> = {}
  for (const [k, v] of Object.entries(data)) {
    normalized[k] = Array.isArray(v) ? v.join(', ') : v
  }
  return t(key, {
    defaultValue: fallback,
    interpolation: { escapeValue: false },
    ...normalized,
  })
}
